import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_EHROrderConfiguration } from './ModuleFE_EHROrderConfiguration.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Action } from '@app/pathway-frontend';
const getOrder = (orderConfig) => {
    const order = ModuleFE_Action.cache.unique(orderConfig.orderId);
    if (!order)
        throw new MUSTNeverHappenException(`Could not get order for id ${orderConfig.orderId}`);
    return order;
};
const Props_DropDown = {
    module: ModuleFE_EHROrderConfiguration,
    modules: [ModuleFE_EHROrderConfiguration],
    mapper: item => [getOrder(item).name],
    placeholder: 'Choose a EHROrderConfiguration',
    renderer: item => _jsxs("div", { className: "ll_h_c", children: [" ", getOrder(item).name] })
};
export const DropDown_EHROrderConfiguration = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_EHROrderConfiguration,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete, className: 'ts-icon__small' }), getOrder(item).name] });
    },
    uiSelector: DropDown_EHROrderConfiguration.selectable,
});
export const MultiSelect_EHROrderConfiguration = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map